import { render, staticRenderFns } from "./netbarmanage.vue?vue&type=template&id=4db9800c&scoped=true"
import script from "./netbarmanage.vue?vue&type=script&lang=js"
export * from "./netbarmanage.vue?vue&type=script&lang=js"
import style0 from "./netbarmanage.vue?vue&type=style&index=0&id=4db9800c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9800c",
  null
  
)

export default component.exports